const drawerWidth = 200;
export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "100vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
  },
  refresh: {
    cursor: "pointer",
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#f9f9fb",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  loadingStyle: {
    height: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  tooltip: {
    color: "#0a1f3a",
    "&:hover": {
      cursor: "pointer",
    },
  },
  paper: { padding: 10 },
});
